<script setup lang="ts">
  import BulletPoint from '../../tips/BulletPoint.vue';
</script>

<template>
  <div>
    <p>
      <BulletPoint />Utilizar as mesmas informações de um documento que já existe, gera uma nova
      revisão daquele documento
    </p>
    <p>
      <BulletPoint />Não adicionar (DE) no nome do arquivo para upload. O prefixo é adicionado
      automaticamente
    </p>
  </div>
</template>
